import privacyManager from "@/services/privacyManager";
export const state = {
  loading: false,
  cron:null,
  isValidPassword:false,
};

import CryptoJS from "crypto-js";
var CryptoJSAesJson = {
  stringify: function (cipherParams) {
    var j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) };
    if (cipherParams.iv) j.iv = cipherParams.iv.toString();
    if (cipherParams.salt) j.s = cipherParams.salt.toString();
    return JSON.stringify(j);
  },
  parse: function (jsonStr) {
    var j = JSON.parse(jsonStr);
    var cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(j.ct),
    });
    if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
    if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
    return cipherParams;
  },
};

export const actions = {
  editUserType({ commit, dispatch }, params) {
    commit("setLoading", true);
    return new Promise((resolve) => {
      privacyManager
        .editUserType(params)
        .then((data) => {
          resolve(data);
          this._vm.$toast.success("Data & Scans Updated");
          dispatch("entity/fetchEntities", data.data.owner_id, { root: true });
          dispatch("userType/fetchUserTypeList", null, { root: true });
          dispatch("getLastCronExecution");
          commit("modal/setModalState", true, { root: true });
          commit("setLoading", false);
        })
        .catch((err) => {
          commit("setLoading", false);
          err.status != 401 && !err.data?.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
  deleteNowUserType({ commit, dispatch }, params) {
    commit("setLoading", true);
    return new Promise((resolve) => {
      privacyManager
        .deleteNowUserType(params)
        .then((data) => {
          resolve(data);
          params.params.type == 'data'
            ?
            this._vm.$toast.success(`${params.params.name ? params.params.name : 'UserType'} Data Deleted`)
            :
            params.params.type == 'scan'
              ?
              this._vm.$toast.success(`${params.params.name ? params.params.name : 'UserType'} Scans Deleted`)
              :
              this._vm.$toast.success(`${params.params.name ? params.params.name : 'UserType'} Data & Scans Deleted`)
          dispatch("userType/fetchUserTypeList", null, { root: true });
          dispatch("getLastCronExecution");
          commit("modal/setModalState", true, { root: true });
          setTimeout(() => { commit("setLoading", false); }, 500);
        })
        .catch((err) => {
          commit("setLoading", true);
          err.status != 401 && !err.data?.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
  togglePrivacyManager({ commit, dispatch }, params) {
    commit("setLoading", true);
    return new Promise((resolve) => {
      privacyManager
        .togglePrivacyManager(params)
        .then((data) => {
          resolve(data);
          dispatch("entity/fetchEntities", data.data.owner_id, { root: true });
          dispatch("userType/fetchUserTypeList", null, { root: true });
          dispatch("getLastCronExecution");
          commit("modal/setModalState", true, { root: true });
          commit("setLoading", false);
        })
        .catch((err) => {
          commit("setLoading", true);
          err.status != 401 && !err.data?.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
  resetValues({ commit }) {
    commit("setLoading", false);
    commit("setIsValidPassword", false);
  },
  getLastCronExecution({ commit }) {
    return new Promise((resolve, reject) => {
      privacyManager
        .getLastCronExecution()
        .then((data) => {
          commit("setCron", data.data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  checkUserPassword({ commit }, params) {
    const key = process.env.VUE_APP_PASSPORT_KEY;
    params = btoa(CryptoJS.AES.encrypt(
      JSON.stringify(params),
      key,
      { format: CryptoJSAesJson }
    ).toString());
    // console.log('params', params);
    return new Promise((reject) => {
      privacyManager
        .checkUserPassword(params)
        .then((data) => {
          const value = JSON.parse(data.data.password.toLowerCase())
          commit("setIsValidPassword",  value);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export const mutations = {
  setLoading(state, payload) {
    state.loading = payload;
  },
  setCron(state, payload) {
    state.cron = payload;
  },
  setIsValidPassword(state, payload) {
    state.isValidPassword = payload;
  },
};

export const getters = {
  getLoading(state) {
    return state.loading;
  },
  getCron(state) {
    return state.cron;
  },
  getIsValidPassword(state) {
    return state.isValidPassword;
  },
};
